export default "__VITE_ASSET__CoKTcdp9__"